import { getProductFlagValues } from 'client/js/main/selectors/ProductSelectors';
import { VidaliaProductService } from 'client/js/main/services/VidaliaProductService';

export const useIsVidaliaEnabled = () => {
  const productFlags = getProductFlagValues();

  const vidaliaProductService = new VidaliaProductService(productFlags);

  return vidaliaProductService.isVidaliaEnabled();
};
